import { Dialog, DialogProps } from "@mui/material";

import AppModalContent from "@/common/components/Modals/AppModalContent";
import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useModalOpenStatus } from "@/common/hooks/modal/useModalOpenStatus";

import { GenericDamageView, GenericDamageViewProps } from "./GenericDamageView";

export interface OwnProps {
  viewProps: GenericDamageViewProps;
}
type Props = OwnProps & DialogProps;

export function GenericDamageViewModal({ viewProps, ...dialogProps }: Props) {
  const openStatus = useModalOpenStatus(dialogProps);

  return (
    <Dialog fullWidth maxWidth='lg' {...dialogProps}>
      <AppModalTitle
        withClose
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >
        Local damage data
      </AppModalTitle>
      <AppModalContent>
        {openStatus.isOpen && (
          <GenericDamageView
            {...viewProps}
            // displayProps={{ viewVariant: ViewLayoutVariant.Modal, ...viewProps?.displayProps }}
          />
        )}
      </AppModalContent>
    </Dialog>
  );
}
